import React from 'react';
import { useNavigate } from 'react-router-dom';
import MainContent from '../components/MainContent';
import { Companion } from '../api/model';
import { ROUTES } from '../routes';

const HomePage: React.FC = () => {
  const navigate = useNavigate();

  const handleStartChat = (companion: Companion) => {
    navigate(ROUTES.CHAT_WITH_COMPANION(companion.id));
  };

  return <MainContent onStartChat={handleStartChat} />;
};

export default HomePage;
